import { arrayOf, bool, func, shape, string } from 'prop-types'
import { PureComponent } from 'react'

import ProductVariantCompact from 'views/components/organisms/ProductVariantsCompact/ProductVariantCompact'
import { isVariantVisible } from 'views/utils/productUtils'
import { ProductVariantType } from 'views/utils/propTypes'

import 'views/components/organisms/ProductVariantsCompact/ProductVariantsCompact.scss'

class ProductVariantsCompact extends PureComponent {
  getInitialState = () => {
    const { variants, currentVariantId } = this.props

    const visibleVariants = variants
      ? variants.filter(variant => isVariantVisible(currentVariantId, variant))
      : []

    return { visibleVariants }
  }

  state = this.getInitialState()

  handleClick = variant => event => {
    const { updateCurrentVariant } = this.props

    if (typeof updateCurrentVariant === 'function') {
      event.preventDefault()
      updateCurrentVariant(variant)
    }
  }

  render() {
    const { currentVariantId, alwaysClickable } = this.props
    const { visibleVariants } = this.state

    return visibleVariants.length ? (
      <ul className="a-list-reset a-list-inline">
        {visibleVariants.map(variant => (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions
          <li
            className="u-margin-small--bottom u-margin-small--right u-vertical-align--middle"
            key={variant.id}
            onClick={this.handleClick(variant)}
          >
            <ProductVariantCompact
              checked={currentVariantId === variant.id}
              variant={variant}
              groupName="packageVariants"
              alwaysClickable={alwaysClickable}
            />
          </li>
        ))}
      </ul>
    ) : null
  }
}

ProductVariantsCompact.propTypes = {
  variants: arrayOf(shape(ProductVariantType)).isRequired,
  currentVariantId: string,
  updateCurrentVariant: func,
  alwaysClickable: bool,
}

ProductVariantsCompact.defaultProps = {
  currentVariantId: null,
  updateCurrentVariant: null,
  alwaysClickable: false,
}

export default ProductVariantsCompact
